import(/* webpackMode: "eager" */ "/home/forge/www.medkart.in/releases/82082909/app/global-error.tsx");
